import { faCamera, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, CircularProgress, FormControlLabel, TextField, Typography, Stack, Tooltip } from "@mui/material";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BucketCarouselFields from "../../components/createBucketComponents/BucketCarouselFields";
import BucketGridFields from "../../components/createBucketComponents/BucketGridFields";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { getConfigFromClientConfig, uploadImages } from "../../services/bannerServices";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  fetchAllBuckets,
  fetchBucketTypeAllOptions,
  getGridOptionMapping,
  updateBucketConfig,
} from "../../services/manageBucketService";
import { metaDataBatchPayload, popupType } from "../../types/types";
import { bucketDesigns, bucketTypes } from "./bucketTypes";
import '../../components/Input/GenericImageUploadComponent.css';

import "./CreateBucket.css";
import Switch from "react-switch";
import { Switch as MUISwitch } from '@mui/material';
import {
  bucketInnerComponent,
  bucketTextFieldDataState,
  bucketTextFieldFlagState,
  configFinalReqBody,
  createBucketNavigate,
  CreateBucketProps,
  gridOptionsData,
  primaryTypeState,
  secondaryTypesState,
  UploadImageButtonType,
  viewType, 
} from "./CreateBucketTypes";
import { Loader } from "../../components/loader/Loader";
import CreateBanner from "../createBanner/CreateBanner";
import { blockInnerComponent, OptionType } from "../manageHomepage/ManageHomePageTypes";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
import { manageUpdateAccessObj } from "../manageUpdateAccess/manageUpdateAccessTypes";
import BannerSelection from "./BannerSelection";
import { Banner, configurationAttributeType } from "../../types";
import { defaultBucketConfig } from "../manageBucket/ManageBucketConfig";
import { getMetaDataConfig, getNewConfiguration, postConfiguration, validateMetaDataResponse } from "../../services/uiConfigService";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import BackButton from "../../components/Buttons/BackButton/BackButton";
import { fetchClientConfig, getAvailableBlockOptionsOfType, getBlockMetaData, getClientConfigDomainType, getConfigKeyValue, getLinkedBlock, getUpdatedRoleAppLayoutConfig, getWholeSellerConfiguration, updateSelectedBlockData } from "../../services/manageHomeScreenService";
import { BlockObjType, BlockSelectionState } from "../createBlock/CreateBlockTypes";
import { defaultBlockObj } from "../createBlock/BlockType";
import { getLob } from "../../services/authenticationService";
import { META_DATA_BATCH_API } from "../../services/networkService";
import { useSelector } from "react-redux";
import store from "../../stateManagement/store";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { pad } from "lodash";

export const UploadImageButton = (props: UploadImageButtonType) => {
  const {translate}=usePortalTranslation();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const validateImageAndUpload = (file: File | undefined) => {
    if (file) {
      let fileType = file.type.split('/')[0];
      let fileExtension = file.type.split("/")[1];

      if (fileType === "image") {
        if (
          props.allowedType &&
          ((props.allowedType === "image" && fileExtension !== "png") ||
            (props.allowedType === "gif" && fileExtension !== "gif") ||
            (props.allowedType === "both" && !["png", "gif"].includes(fileExtension)))
        ) {
          openPopup(
            "Alert",
            `Only ${props.allowedType === "both" ? "PNG or GIF" : props.allowedType.toUpperCase()} files are allowed`
          );
          return;
        }
        const allowedGifSize = props.maxGifSize ? props.maxGifSize : 10 * 1024 * 1024; //default 10MB
        if (fileExtension === "gif" && file.size > allowedGifSize) {
          openPopup("Alert", `GIF size must not exceed ${allowedGifSize} KB`);
          return;
        }

        let img = new Image();
        let objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          if (
            img.naturalHeight !== props.resolution.height ||
            img.naturalWidth !== props.resolution.width
          ) {
            openPopup(
              "Alert",
              `The required image resolution is ${props.resolution.width}X${props.resolution.height}. Your image has a resolution of ${img.naturalWidth}X${img.naturalHeight}`
            );
          } else {
            props.setImage(file);
            props.setDefaultImage("");
          }
          URL.revokeObjectURL(objectUrl);
        };
        img.onerror = function () {
          openPopup("Alert", "Failed to load image. Please try again.");
          URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      } else {
        openPopup("Alert", "Please choose an image");
      }
    }
  };



  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    if(event.target?.files){
      //validatation to be written here (if required)
      validateImageAndUpload(event.target.files?.[0]);
    }
  }
  const handleClick = () => {
    if(fileInputRef.current){
      fileInputRef.current.value = "";
      fileInputRef.current.click();
      props.setImage(null);
    }
  }
  const handleCrossButton = () => {
    if(props.image){
      props.setImage(null);
    }
    if(props.defaultImage){
      props.setDefaultImage("");
    }
  }
  return (<div className={"genericImageUploadContainer" + (props.className? ` ${props.className}`: "")}>
        <div className="genericImageUpload" 
        onClick={handleClick}
        >
        
          {props.image ? (
            <> 
                <img
                  src={URL.createObjectURL(props.image)}
                  height="60"
                  width="auto"
                  alt="banner preview"
                />
            </>
          ) : props.defaultImage ? (
            <> 
                <img
                  src={props.defaultImage}
                  height="60"
                  width="auto"
                  alt="banner preview"
                />
            </>
          ) : (
            <>
              <FontAwesomeIcon fontSize="45px" icon={faCamera} />
              <Typography variant="subtitle1">
              {`${translate(TranslationEnum.common_portal, props.label)} (${props.size || `${props.resolution.width}X${props.resolution.height}`})`}
              </Typography>
            </>
          )}
          <input
            type="file"
            accept={
              props.allowedType
                ? props.allowedType === "image"
                  ? "image/png"
                  : props.allowedType === "gif"
                  ? "image/gif"
                  : "image/png,image/gif"
                : "image/png,image/gif"
            }
            onChange={handleImageUpload}
            hidden
            ref={fileInputRef}
          />
        </div>
        {props.image || props.defaultImage?<div className="genericImageUploadCrossContainer">
          <FontAwesomeIcon
                className="genericImageUploadCross"
                icon={faXmark}
                onClick={handleCrossButton}
            />
        </div> : <></>}
      </div>)
}

function CreateBucket(props: CreateBucketProps) {
  const [maxGifSize, setMaxGifSize] = useState<number | undefined>(undefined);
  const [viewAll,setViewAll] = useState<boolean>(false)
  const [sticky,setSticky] = useState<boolean>(false)
  const [allowed1DGrid,setAllowed1DGrid] = useState<boolean>(false)
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newValue = checked ? true : false; 
    setViewAll(newValue)
  };
  const handleStickyToggle = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newValue = checked ? true : false; 
    setSticky(newValue)
  };
  const {translate}=usePortalTranslation();
  const navigate = useNavigate();
  const [bucketTextFieldData, setBucketTextFieldData] =
    useState<bucketTextFieldDataState>({
      id: "",
      title: "",
      subtitle: "",
    });
  const [bucketTextFieldFlag,setBucketTextFieldFlag] = useState<bucketTextFieldFlagState>({
    id: false,
    title: false,
    subtitle: false
  });
  const location = useLocation();
  const [hideAllInputs,setHideAllInputs] = useState<boolean>(false); //hide all other inputs for update page(partialEdit page)
  const locationState: createBucketNavigate = location.state as createBucketNavigate;
  const currentBucketLocationData = locationState?.currentBucket;
  const bucketConfigurationRef = useRef<any[]>(defaultBucketConfig);
  const [bucketBackgroundType, setBucketBackgroundType] =
    useState<string>("Color");
  const [bucketBackgroundColor, setBucketBackgroundColor] =
    useState<string>("#ffffff");
  const [bucketStaticColor, setBucketStaticColor] =
    useState<string>("");
  const [minBoxes, setMinBoxes] = useState<string>("");
  const [isValidColor, setIsValidColor] = useState<boolean>(true);
  const [bucketBackgroundImage, setBucketBackgroundImage] =
    useState<File | null>(null);
    const [bucketGIFImage, setBucketGIFImage] =
    useState<File | null>(null);
  const [bucketDesign, setBucketDesign] = useState<string>("");
  const [bucketDesignOption,setBucketDesignOption] = useState({
    label: "",
    id: ""
  });
  const [primaryTypeOptions, setPrimaryTypeOptions] = useState<string[]>([]);
  const [primaryType, setPrimaryType] = useState<string>("");
  const [secondaryType, setSecondaryType] = useState<string>("");
  const [packSizes, setPackSizes] = useState<string[]>([]);
  const [pieceSizeDesc, setPieceSizeDesc] = useState<string[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [subBrand, setSubBrand] = useState<string[]>([]);
  const [brandCode, setBrandCode] = useState<string[]>([]);
  const [subCategory, setSubCategory] = useState<string[]>([]);
  const [smartBuys,setSmartBuys] = useState<string[]>([]);
  const [brands, setBrands] = useState<string[]>([]);
  const [selectedPrimaryTypes, setSelectedPrimaryTypes] = useState<string[]>(
    []
  );
  const [selectedPrimaryTypesState, setSelectedPrimaryTypesState] = useState<
    primaryTypeState[] | Banner[]
  >([]);
  const [secondaryBucketTypes, setSecondaryBucketTypes] = useState<string[]>(
    []
  );
  const [view, setView] = useState<viewType>("create");
  const [bucketBackgroundBlobkey, setBucketBackgroundBlobkey] =
    useState<string>("");
    const [bucketBackgroundGIF, setBucketBackgroundGIF] =
    useState<string>("");

  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [secondaryTypeOptions, setSecondaryTypeOptions] = useState<string[]>(
    []
  );
  const [gridDataMapping,setGridDataMapping] = useState<gridOptionsData[]>([])
  const [showSubmitLoader,setShowSubmitLoader] = useState<boolean>(false);
  const [showLoader,setShowLoader] = useState<boolean>(false);
  const [gridDataLoader,setGridDataLoader] = useState<boolean>(false);
  const [bannerIcon,setBannerIcon] = useState<File | null>(null);
  const [bannerIconBlobKey,setBannerIconBlobKey] = useState<string>("");
  const [titleColorToggle,setTitleColorToggle] = useState<boolean>(false);
  const [subtitleColorToggle,setSubtitleColorToggle] = useState<boolean>(false);
  const bucketConfigExists = useRef<boolean>(false);
  const clientConfigRef = useRef<any[]>([]);
  const allBlocksRef = useRef<BlockObjType[]>([]);
  const [blockSelectionState,setBlockSelectionState] = useState<BlockSelectionState>({
    selectedBlock: defaultBlockObj,
    blockOptions: [],
    blockConfigEnabled: false,
    isChanged: false
  })
  const savedRole:any = useSelector(() => store.getState().roleState.role)
  const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
  const [startDate, setStartDate] = React.useState<Dayjs | null>(
    null
  );
  let previousDate = new Date();
  previousDate.setDate((new Date()).getDate() - 1);
  const prevDate = dayjs(previousDate).format("YYYY-MM-DD");
  const [endDate, setEndDate] = React.useState<Dayjs | null>(
    null
  );
  const [dateValidation,setDateValidation] = useState({ startDate: "", endDate: "" })
  const handleStartDate = (newValue: Dayjs | null) => {
    let message = "";
    let endDateMessage = dateValidation.endDate;
    if(!newValue?.isValid()){
        message = "Not a Valid Date";
    }else if(newValue.format("YYYY-MM-DD")<prevDate){
        message = "Start Date can't be less than yesterday date";
    }
    if(endDate?.isValid() && newValue?.isValid()){
        if(endDate.format("YYYY-MM-DD")<newValue.format("YYYY-MM-DD"))
            endDateMessage = "End Date can't be less than Start Date";
        else
            endDateMessage = "";
    }
    setDateValidation({
        ...dateValidation,
        startDate: message,
        endDate: endDateMessage
    })
    setStartDate(newValue);
  }
  const handleEndDate = (newValue: Dayjs | null) => {
    let message = "";
    if(!newValue?.isValid()){
        message = "Not a Valid Date"
    }else if(startDate?.isValid){
        if(newValue.format("YYYY-MM-DD")<startDate.format("YYYY-MM-DD")){
            message = "End Date can't be less than Start Date";
        }
    }
    setDateValidation({
        ...dateValidation,
        endDate: message
    })
    setEndDate(newValue);
  }
  const [wholeSellerConfig, setWholeSellerConfig] = useState<boolean>(false);
    useEffect(() => {
    const fetchPortalConfig = async () => {
      const portalConfig = await getMetaDataConfig(
        "clientConfig",
        "portal_configuration"
      );
      const portal_config: configurationAttributeType[] =
        portalConfig?.domainValues ?? [];
    
      const wholeSellerConfig = portal_config?.find(
        (item) => item.name === "wholeSellerConfig"
      )?.value ?? false; 
      setWholeSellerConfig(wholeSellerConfig);
      const bannerConfig = await getNewConfiguration('banner_configuration');
      const bannerConfigValue = bannerConfig && bannerConfig?.domainValues?.[0].value;
      const bannerGIF = bannerConfigValue && bannerConfigValue.find((item: { name: string; }) => item.name === "maxGifSize");
      setMaxGifSize(bannerGIF?.value);
    };
    fetchPortalConfig();
  }, []);
  useEffect(() => {
    async function fetchAndSetAllTypes() {
      setShowLoader(true);
      const clientConfig = await fetchClientConfig();
      clientConfigRef.current = clientConfig;
      const bucketConfig = getConfigFromClientConfig(clientConfig,"bucket_configuration");
      const role = "retailer";
      const RoleConfigName = `${savedRole?.id}_app_layout_configuration`;
      const roleAppLayoutConfig = getConfigFromClientConfig(clientConfig,RoleConfigName);
      
      const allBlocks = getConfigKeyValue(roleAppLayoutConfig,"homeScreenBlockWidget")
      const newBlockSelectionState = {...blockSelectionState}
      if(allBlocks && Array.isArray(allBlocks)){
        newBlockSelectionState.blockConfigEnabled = true;
        allBlocksRef.current = allBlocks;
      }else{
        allBlocksRef.current = []
      }
      let currentBucket = currentBucketLocationData;
      if(bucketConfig){
        const allBuckets = bucketConfig?.[0]?.value || [];
        const has1DGridBucket = allBuckets.some(
          (bucket: any) => bucket.bucketDesign === "1DGrid"
        );
        setAllowed1DGrid(!has1DGridBucket);
        bucketConfigurationRef.current = bucketConfig;
        bucketConfigExists.current = true;
        if(currentBucketLocationData){
          const tempCurBucket = bucketConfig[0].value.find((bucketData: any) => {
            return bucketData.id === currentBucketLocationData.id;
          });
          currentBucket = tempCurBucket ?? currentBucket;
        }
      }
      const pieceSizeOptions = await fetchBucketTypeAllOptions("pieceSizeDesc");
      setPieceSizeDesc(pieceSizeOptions);
      const packSizeOptions = await fetchBucketTypeAllOptions("pieceSize");
      setPackSizes(packSizeOptions);
      const categoryOptions = await fetchBucketTypeAllOptions("category");
      setCategories(categoryOptions);
      const brandOptions = await fetchBucketTypeAllOptions("brand");
      setBrands(brandOptions);
      const smartBuyOptions = await fetchBucketTypeAllOptions("smartBuy");
      setSmartBuys(smartBuyOptions);
      const subCategoryOptions = await fetchBucketTypeAllOptions("subCategory");
      setSubCategory(subCategoryOptions);
      const subBrandOptions = await fetchBucketTypeAllOptions("subBrand");
      setSubBrand(subBrandOptions);
      const brandCodeOptions = await fetchBucketTypeAllOptions("brandCode");
      setBrandCode(brandCodeOptions);
      if(locationState?.blockData){
        
        setBucketDesign(locationState?.blockData.bucketDesign);
        const selectedBucketDesignOption = bucketDesigns.find((option: {id: string,label: string}) => option.id === locationState?.blockData.bucketDesign );
        setBucketDesignOption(selectedBucketDesignOption!);

        const templateFilteredBlocks = getAvailableBlockOptionsOfType("Bucket", allBlocks!, locationState?.blockData.bucketDesign);
            setBlockSelectionState((prevState) => {
                return {
                    ...prevState,
                    blockOptions: templateFilteredBlocks,
                    selectedBlock: locationState?.blockData,
                    isChanged: true,
                    blockConfigEnabled: true
                }
            })
            // console.log("blockSelectionState",blockSelectionState)
      }
      if (currentBucket) {
        if(newBlockSelectionState.blockConfigEnabled){
          const availableBlockOptions = getAvailableBlockOptionsOfType("Bucket",allBlocks!,currentBucket.bucketDesign)
          const linkedBlock = getLinkedBlock(allBlocks!,"Bucket",currentBucket.id);
          if(linkedBlock?.id){
            newBlockSelectionState.selectedBlock = linkedBlock;
            newBlockSelectionState.blockOptions = [...availableBlockOptions,linkedBlock];
          }else{
            newBlockSelectionState.blockOptions = [...availableBlockOptions];
          }
        }
        setView("edit");
        setHideAllInputs(true);
        const { id, title, subtitle, primarySource,viewAll, sticky, minBoxes} = currentBucket;
        if(viewAll){
          setViewAll(viewAll)
        }
        if(sticky){
          setSticky(sticky)
        }
        if(minBoxes){
          setMinBoxes(minBoxes)
        }
        setBucketTextFieldData({ id, title, subtitle });
        setTitleColorToggle(Boolean(currentBucket.titleColor==="#ffffff"))
        setSubtitleColorToggle(Boolean(currentBucket.subTitleColor==="#ffffff"));

        setBucketDesign(currentBucket.bucketDesign);
        const selectedBucketDesignOption = bucketDesigns.find((option: {id: string,label: string}) => option.id === currentBucket.bucketDesign );
        setBucketDesignOption(selectedBucketDesignOption!);
        setPrimaryType(primarySource==="pieceSize"? "Pack Size" : primarySource==="pieceSizeDesc"? "Piece Size Description" : primarySource);
        let allPrimaryOptions:string[] = [];
          if (primarySource === "pieceSize") {
            allPrimaryOptions = packSizeOptions;
          } else if (primarySource === "Category") {
            allPrimaryOptions = categoryOptions;
          } else if(primarySource === "Brand"){
            allPrimaryOptions = brandOptions;
          }else if(primarySource === "Sub Brand"){
            allPrimaryOptions = subBrandOptions;
          }else if(primarySource === "Brand Code"){
            allPrimaryOptions = brandCodeOptions;
          }else if(primarySource === "Sub Category"){
            allPrimaryOptions = subCategoryOptions;
          }else if(primarySource === "pieceSizeDesc"){
            allPrimaryOptions = pieceSizeOptions;
          }else {
            allPrimaryOptions = smartBuyOptions;
          }
        if (currentBucket.bucketDesign === "Carousel" || currentBucket.bucketDesign === "1DGrid") {
          if (currentBucket.backgroundColor) {
            setBucketBackgroundType("Color");
            setBucketBackgroundColor(currentBucket.backgroundColor);
          } else {
            setBucketBackgroundType("Image");
            setBucketBackgroundBlobkey(currentBucket.backgroundBlobKey);
            setBucketStaticColor(currentBucket.bucketStaticColor);
          }
          const primaryTypesState = currentBucket.primarySourceOptions.map(
            (option: any) => {
              const value = option.name;
              delete option.name;
              return {
                ...option,
                inputRef: null,
                value
              };
            }
          );
          const finalPrimaryOptions = allPrimaryOptions.filter(
            (option: string) => {
              const index = primaryTypesState.findIndex(
                (primaryOption: primaryTypeState) => {
                  return option === primaryOption.value;
                }
              );
              return index === -1;
            }
          );
          setPrimaryTypeOptions(finalPrimaryOptions);
          setSelectedPrimaryTypesState(primaryTypesState as primaryTypeState[]);

        } else if (currentBucket.bucketDesign === "Grid") {
          const secondarySource = currentBucket.secondarySource;
          const tempSecondaryType = secondarySource==="pieceSize"? "Pack Size" : secondarySource==="pieceSizeDesc"? "Piece Size Description" : secondarySource;
          setSecondaryType(tempSecondaryType);
        let allSecondaryOptions:string[] = [];
        if (secondarySource === "pieceSize") {
          allSecondaryOptions = packSizeOptions;
        } else if (secondarySource === "Category") {
          allSecondaryOptions = categoryOptions;
        } else if(secondarySource === "Brand") {
          allSecondaryOptions = brandOptions;
        }else if(primarySource === "Sub Brand"){
          allSecondaryOptions = subBrandOptions;
        }else if(primarySource === "Brand Code"){
          allSecondaryOptions = brandCodeOptions;
        }else if(primarySource === "Sub Category"){
          allSecondaryOptions = subCategoryOptions;
        }else if(secondarySource === "pieceSizeDesc") {
          allSecondaryOptions = pieceSizeOptions;
        }else{ 
          allSecondaryOptions = smartBuyOptions;
        }
        const gridData = await getGridOptionMapping(primarySource==="pieceSize"? "Pack Size" : primarySource==="pieceSizeDesc"? "Piece Size Description" : primarySource,tempSecondaryType,allPrimaryOptions);
        setGridDataMapping(gridData);
        const primarySourceOptions = currentBucket.primarySourceOptions.map((primaryOption: any) => {
            return {
              id: primaryOption.id,
              inputRef: null,
              value: primaryOption.name,
              blobKey: primaryOption.blobKey,
              color: primaryOption.color,
              activeStatus: primaryOption.activeStatus,
              secondaryTypeOptions: primaryOption.secondarySourceOptions.map((secondaryOption:any) => {
                return {
                  id: secondaryOption.id,
                  inputRef: null,
                  value: secondaryOption.name,
                  blobKey: secondaryOption.blobKey,
                }
              }),
              availableSecondaryTypes: gridData.find((gridOption: gridOptionsData) => {
                return gridOption.name === primaryOption.name;
              })?.secondaryOptions?.filter((secondaryOptionName: string) => {
                return primaryOption.secondarySourceOptions.findIndex((secondaryOption: any) => secondaryOption.name === secondaryOptionName) === -1
              }) || [],
              selectedSecondaryTypes: [],
            }
          })
          const finalPrimaryOptions = allPrimaryOptions.filter(
            (option: string) => {
              const index = primarySourceOptions.findIndex(
                (primaryOption: primaryTypeState) => {
                  return option === primaryOption.value;
                }
              );
              return index === -1;
            }
          );
          setPrimaryTypeOptions(finalPrimaryOptions);
          setSelectedPrimaryTypesState(primarySourceOptions as primaryTypeState[]);
        }else if(currentBucket.bucketDesign==="Need Based Basket Banner"){
          if (currentBucket.backgroundColor) {
            setBucketBackgroundType("Color");
            setBucketBackgroundColor(currentBucket.backgroundColor);
          } else {
            setBucketBackgroundType("Image");
            setBucketBackgroundBlobkey(currentBucket.backgroundBlobKey);
          }
          setBannerIconBlobKey(currentBucket.bannerIconBlobKey)
        }else if(currentBucket.bucketDesign==="campaignBanner"){
          
          if (currentBucket.backgroundColor) {
            setBucketBackgroundColor(currentBucket.backgroundColor);
          }
          if (currentBucket.backgroundGIFBlobKey) {
            setBucketBackgroundGIF(currentBucket.backgroundGIFBlobKey);
          }
          if(currentBucket.startDate){
          setStartDate(dayjs(currentBucket.startDate));
          }
          if(currentBucket.endDate){
          setEndDate(dayjs(currentBucket.endDate));
          }

        }
      }
      if(!locationState?.blockData){
        setBlockSelectionState(newBlockSelectionState);
      }
      setShowLoader(false);
    }
    fetchAndSetAllTypes();
  }, [savedRole]);
  
  // console.log("blockSelectionState",blockSelectionState)
  function renderBucketTypeInputs() {
    switch (bucketDesign) {
      case "1DGrid":
      case "Carousel": {
        return (
          <BucketCarouselFields
            width={bucketDesign === "1DGrid" ? 72 : 210}
            heigth={bucketDesign === "1DGrid" ? 32 : 240}
            bucketDesign={bucketDesign}
            bucketTextFieldData={bucketTextFieldData}
            view={hideAllInputs? "partialEdit" : view}
            selectedPrimaryTypes={selectedPrimaryTypes}
            primaryTypeOptions={primaryTypeOptions}
            primaryType={primaryType}
            selectedPrimaryTypesState={selectedPrimaryTypesState as primaryTypeState[]}
            setSelectedPrimaryTypesState={setSelectedPrimaryTypesState as React.Dispatch<React.SetStateAction<primaryTypeState[]>>}
            setSelectedPrimaryTypes={setSelectedPrimaryTypes}
            setPrimaryTypeOptions={setPrimaryTypeOptions}
          />
        );
      }
      case "Grid": {
        return (
          <>
            {!hideAllInputs && <>
              <label className="create-basket-input-labels">
              {translate(TranslationEnum.manage_bucket,"BUCKET SUB-TYPE")}
              </label>
              <Autocomplete
                disableClearable
                sx={{ width: "100%" }}
                value={secondaryType}
                onChange={async (event, value: string) => {
                  setGridDataLoader(true);
                  setSecondaryType(value);
                  let tempPrimaryOptions: string[];
                  if (primaryType === "Pack Size") {
                    setPrimaryTypeOptions(packSizes);
                    tempPrimaryOptions = packSizes;
                  } else if (primaryType === "Category") {
                    setPrimaryTypeOptions(categories);
                    tempPrimaryOptions = categories;
                  } else if (primaryType === "Brand") {
                    setPrimaryTypeOptions(brands);
                    tempPrimaryOptions = brands;
                  }else if (primaryType === "Sub Category") {
                    setPrimaryTypeOptions(subCategory);
                    tempPrimaryOptions = subCategory;
                  }else if (primaryType === "Sub Brand") {
                    setPrimaryTypeOptions(subBrand);
                    tempPrimaryOptions = subBrand;
                  } else if (primaryType === "Piece Size Description") {
                    setPrimaryTypeOptions(pieceSizeDesc);
                    tempPrimaryOptions = pieceSizeDesc;
                  }else if (primaryType === "Brand Code") {
                    setPrimaryTypeOptions(brandCode);
                    tempPrimaryOptions = brandCode;
                  } else {
                    setPrimaryTypeOptions(smartBuys);
                    tempPrimaryOptions = smartBuys;
                  }
                  if(selectedPrimaryTypesState.length>0){
                      setSelectedPrimaryTypesState([]);
                  }
                  const gridData = await getGridOptionMapping(primaryType,value,tempPrimaryOptions);
                  setGridDataMapping(gridData); 
                  setGridDataLoader(false);
                }}
                options={secondaryBucketTypes}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={translate(TranslationEnum.manage_bucket,"Select Bucket Sub-Type")}
                  />
                )}
              />
            </>}
            <BucketGridFields
              view={hideAllInputs? "partialEdit" : view}
              gridDataLoader={gridDataLoader} 
              gridDataMapping = {gridDataMapping}
              secondaryTypeOptions={secondaryTypeOptions}
              selectedPrimaryTypes={selectedPrimaryTypes}
              setSelectedPrimaryTypes={setSelectedPrimaryTypes}
              setPrimaryTypeOptions={setPrimaryTypeOptions}
              primaryTypeOptions={primaryTypeOptions}
              primaryType={primaryType}
              selectedPrimaryTypesState={selectedPrimaryTypesState as primaryTypeState[]}
              setSelectedPrimaryTypesState={setSelectedPrimaryTypesState as React.Dispatch<React.SetStateAction<primaryTypeState[]>>}
              secondaryType={secondaryType}
            />
          </>
        );
      }
      case "Need Based Basket Banner": {
        return <>
               {!hideAllInputs && <>
                <label className="create-basket-input-labels">
                {translate(TranslationEnum.manage_bucket,"BANNER ICON")}
                </label>
                <UploadImageButton resolution={{ width: 90, height: 90 }} label="Upload Banner Icon" image={bannerIcon} setImage={setBannerIcon} defaultImage={bannerIconBlobKey} setDefaultImage={setBannerIconBlobKey} />
               </>}
                {/* <CreateBanner bucketView={view} bucketId={bucketTextFieldData.id} handleBucketDataSubmit={handleBucketSubmit} validateAllBucketInputs={validateAllInputs} /> */}
                <BannerSelection label="Need Based Basket Banners" bannerTemplates={["template8","template29"]} selectedPrimaryTypesState={selectedPrimaryTypesState as Banner[]} setSelectedPrimaryTypesState={setSelectedPrimaryTypesState as React.Dispatch<React.SetStateAction<Banner[]>>} view={view}/>
               </>
      }
      case "campaignBanner": {
        return <>
                <BannerSelection label="Campaign Banner" bannerTemplates={["template999"]} selectedPrimaryTypesState={selectedPrimaryTypesState as Banner[]} setSelectedPrimaryTypesState={setSelectedPrimaryTypesState as React.Dispatch<React.SetStateAction<Banner[]>>} view={view}/>
               </>
      }
      case "basketBannerOneClick": {
        return <BannerSelection label="Basket Banner One Click" bannerTemplates={["template32"]} selectedPrimaryTypesState={selectedPrimaryTypesState as Banner[]} setSelectedPrimaryTypesState={setSelectedPrimaryTypesState as React.Dispatch<React.SetStateAction<Banner[]>>} view={view}/>
      }
      default: return <></>;
    }
  }

  const validIdValue = (id: string) => {
    return /^[a-zA-Z0-9_]*$/i.test(id)
  }
  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const colour = event.target.value;
    if (colour.length === 0 || !isValidHexColor(colour)) {
      setIsValidColor(false);
    } else {
      setIsValidColor(true);
    }
    setBucketBackgroundColor(colour);
  };
   const handleStaticColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const colour = event.target.value;
    if (colour.length === 0 || !isValidHexColor(colour)) {
      setIsValidColor(false);
    } else {
      setIsValidColor(true);
    }
    setBucketStaticColor(colour);
  };
  const isValidHexColor = (colorString: string) => {
    if (colorString.length < 7) {
      return false;
    }
    return /^#([0-9A-F]{3}){1,2}$/i.test(colorString);
  };
  const renderBackgroundInput = () => {
    if (!bucketBackgroundType) return <></>;
    if (bucketDesign === "campaignBanner")
    return <div style={{marginTop:"15px",display:"flex",gap:"10px"}}>
      BACKGROUND TYPE{" "}
      <TextField
        id="outlined-start-adornment"
        size="small"
        value={bucketBackgroundColor}
        placeholder={"#ffffff"}
        onChange={handleColorChange}
        InputProps={{
          endAdornment: (
            <input
              type="color"
              style={{padding: "0"}}
              id="color-picker"
              value={bucketBackgroundColor}
              onChange={handleColorChange}
            />
          ),
        }}
        error={!isValidColor}
        helperText={!isValidColor && "Please select a valid hex code"}
      /></div>;
    if(bucketDesign==="Carousel" || bucketDesign==="1DGrid" || bucketDesign==="Need Based Basket Banner"){
        switch (bucketBackgroundType) {
            case "Color":
              return (
                <>
                  <TextField
                    id="outlined-start-adornment"
                    size="small"
                    value={bucketBackgroundColor}
                    placeholder={"#ffffff"}
                    onChange={handleColorChange}
                    InputProps={{
                      endAdornment: (
                        <input
                          type="color"
                          id="color-picker"
                          value={bucketBackgroundColor}
                          style={{ width: "60px", padding: "1px" }}
                          onChange={handleColorChange}
                        />
                      ),
                    }}
                    error={!isValidColor}
                    helperText={!isValidColor && "Please select a valid hex code"}
                  />
                </>
              );
            case "Image":
              return (
                <>
                  <UploadImageButton
                    label={"BACKGROUND IMAGE"}
                    setImage={setBucketBackgroundImage}
                    image = {bucketBackgroundImage}
                    defaultImage={bucketBackgroundBlobkey}
                    setDefaultImage={setBucketBackgroundBlobkey}
                    resolution={{
                      width:bucketDesign==="1DGrid" ? 390 : 720,
                      height:bucketDesign==="1DGrid" ? 170 : 600
                    }}
                  />
                </>
              );
          }
    }else{
        return <></>;
    }
    
  };
  const idValidationText = () => {
    if(!bucketTextFieldData.id){
      return "Please enter a ID";
    }
    if(view==='create' && !isValidBucketId()){
      return `Bucket with ID: ${bucketTextFieldData.id} already exists`;
    }
    if(!validIdValue(bucketTextFieldData.id)){
      return "ID can only contain alphabets and numbers"
    }
    return "";
  }
  const subtitleValidationText = () => {
    if(bucketTextFieldData.subtitle.length>50){
      return "Subtitle can be of maximum 50 characters";
    }
    return "";
  }
  const titleValidationText = () => {
    if(!bucketTextFieldData.title){
      return "Please enter a title";
    }
    if(bucketTextFieldData.title.trim().length===0){
      return "Title must not be empty spaces"
    }
    if(bucketTextFieldData.title.length>20){
      return "Title can be of maximum of 20 characters";
    }
  }
  
  const isValidBucketId = () => {
    //should check for numeric?
    const allBuckets = bucketConfigurationRef.current[0].value;
    const index = allBuckets.findIndex(
      (bucket: any) => bucket.id === bucketTextFieldData.id
    );
    return index === -1;
  };
  const idHelperText = idValidationText();
  const titleHelperText = titleValidationText();
  const subtitleHelperText = subtitleValidationText();

  const validateAllInputs = () => {
    let message = "";
    if(props.validateAllParentInputs) message = props.validateAllParentInputs();
    if(message!=="") return message;
    let invalidCount = 0;
    // if (idHelperText) {
    //   message = idHelperText;
    //   invalidCount++;
    // }
    if (invalidCount < 2 && titleHelperText && bucketDesign!="1DGrid") {
      message = titleHelperText;
      invalidCount++;
    }
    if (invalidCount < 2 && subtitleHelperText && bucketDesign!="1DGrid") {
      message = subtitleHelperText;
      invalidCount++;
    }
    if (invalidCount < 2 && (bucketDesign==="Carousel"  || bucketDesign==="1DGrid") && !bucketBackgroundType) {
      message = "Please select a valid background type";
      invalidCount++;
    }
    if(invalidCount < 2 && blockSelectionState.blockConfigEnabled && !blockSelectionState.selectedBlock.id){
      message = "Please select a block";
      invalidCount++;
    }
    if (
      invalidCount < 2 &&
      (bucketDesign==="Carousel" || bucketDesign==="1DGrid" || bucketDesign==="Need Based Basket Banner") &&
      bucketBackgroundType === "Image" &&
      !bucketBackgroundImage &&
      !bucketBackgroundBlobkey
    ) {
      message = "Please select a valid background Image";
      invalidCount++;
    } else if (
      invalidCount < 2 && 
      (bucketDesign==="Carousel" || bucketDesign==="1DGrid" || bucketDesign==="Need Based Basket Banner") &&
      bucketBackgroundType === "Color" &&
      !isValidColor
    ) {
      message = "Please select a valid background color";
      invalidCount++;
    }
    const isBannerTypeBucket = ["Need Based Basket Banner","basketBannerOneClick","campaignBanner"].includes(bucketDesign);
    if (invalidCount < 2 && !isBannerTypeBucket && !primaryType) {
      message = "Please select a Bucket Type";
      invalidCount++;
    }
    if (bucketDesign === "Carousel"  || bucketDesign==="1DGrid") {
      if (invalidCount < 1 && selectedPrimaryTypesState.length === 0) {
        message = "Please select and add atleast one " + primaryType;
        invalidCount++;
      } else if (invalidCount < 1 && selectedPrimaryTypesState.length > 0) {
        let carouselImageInvalidCount = 0;
        for (let num = 0; num < selectedPrimaryTypesState.length; num++) {
          if (selectedPrimaryTypesState[num]) {
            const caraouselItem = selectedPrimaryTypesState[num] as primaryTypeState;
            if (
                carouselImageInvalidCount < 1 &&
              (!caraouselItem.inputRef || !caraouselItem.inputRef.files?.[0]) &&
              !caraouselItem.blobKey
            ) {
              message = "Please add images for all Grid items, or remove unnecessary items"; 
              carouselImageInvalidCount++;
            }
            else if(carouselImageInvalidCount>1){
                break;
            }
          }
        }
      }
    } else if (bucketDesign === "Grid") {
      if (invalidCount < 1 && !secondaryType) {
        message = "Please select a Bucket Sub-Type";
      }
      if (invalidCount < 1 && selectedPrimaryTypesState.length === 0) {
        message = "Please select and add atleast one " + primaryType;
        invalidCount++;
      }
      let gridImageInvalidCount = 0;
      for(let pIdx=0;pIdx<selectedPrimaryTypesState.length;pIdx++){
        const primaryItem = selectedPrimaryTypesState[pIdx] as primaryTypeState;
        if(gridImageInvalidCount<1 && (!primaryItem.inputRef || !primaryItem.inputRef.files?.[0]) && !primaryItem.blobKey){
            message = "Please add images for all 2D Grid items, or remove unnecessary items";
            gridImageInvalidCount++;
        }else if(gridImageInvalidCount>1){
            break;
        }
        if(primaryItem.secondaryTypeOptions){
            const secondaryItems = primaryItem.secondaryTypeOptions;
            for(let sIdx=0;sIdx<secondaryItems.length;sIdx++){
                const secondaryItem = secondaryItems[sIdx];
                if(gridImageInvalidCount<1 && (!secondaryItem.inputRef || !secondaryItem.inputRef.files?.[0]) && !secondaryItem.blobKey){
                    message = "Please add images for all 2D Grid items, or remove unnecessary items";
                    gridImageInvalidCount++;
                }else if(gridImageInvalidCount>1){
                    break;
                }
            }
        }
      }
    }else if(bucketDesign==="Need Based Basket Banner"){
        
    }
    return invalidCount < 2
      ? message
      : "Multiple Fields are invalid, please fill all the required fields to continue";
  };
  const handleBucketSubmit = async (innerComponentData?: bucketInnerComponent | blockInnerComponent,verifiedUser?: manageUpdateAccessObj) => {
    try {
      setShowSubmitLoader(true);
      if(!innerComponentData){
        const validationMessage = validateAllInputs();
        if (validationMessage !== "") {
          setPopupMessage(validationMessage);
          setPopupType("Alert");
          setOpenGenericModal(true);
          setShowSubmitLoader(false);
          return;
        }
      }
      if(bucketDesign==="campaignBanner"){
        if (!startDate || !endDate) {
          openPopup("Error", "Please input start date and end date")
          setShowSubmitLoader(false);
          return;
        }
        if (dateValidation.startDate || !startDate?.isValid()) {
          openPopup("Error", "Please input correct start date")
          setShowSubmitLoader(false);
          return;
        }
        if (dateValidation.endDate || !endDate?.isValid()) {
          openPopup("Error", "Please input correct end date")
          setShowSubmitLoader(false);
          return;
        }
        if(!bucketGIFImage && !bucketBackgroundGIF){
          openPopup("Error", "Please upload GIF")
          setShowSubmitLoader(false);
          return;

        }
      }
      //creating form data for all images
      let imagesPayload = new FormData();

      const allBuckets = bucketConfigurationRef.current[0].value as any[];
      let newAllBuckets = [...allBuckets];
      const bucketConfiguration = [...bucketConfigurationRef.current];
      const trimmedTextFieldData: bucketTextFieldDataState = {
        id: (view==="create" && !currentBucketLocationData)? new Date().getTime().toString() : currentBucketLocationData.id ,
        title: bucketTextFieldData.title.trim(),
        subtitle: bucketTextFieldData.subtitle.trim(),
      }
      if (bucketDesign === "Carousel" || bucketDesign==="1DGrid") {
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
            imagesPayload.append("files", bucketBackgroundImage);
        }
        for (let num = 0; num < selectedPrimaryTypesState.length; num++) {
          const caraouselItem = selectedPrimaryTypesState[num] as primaryTypeState;
          if (caraouselItem.inputRef?.files?.[0])
            imagesPayload.append("files", caraouselItem.inputRef?.files?.[0]);
        }
        const blobUrls = imagesPayload.has("files")
          ? await uploadImages(imagesPayload)
          : [];
        if (!Array.isArray(blobUrls)) {
          setOpenGenericModal(true);
          setPopupMessage(blobUrls.message);
          setPopupType("Error");
          setShowSubmitLoader(false);
          return;
        }
        let blobIdx = 0;
        let backgroundBlobKey = "";
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
          backgroundBlobKey = blobUrls[0];
          blobIdx++;
        }
        const primarySourceOptions = (selectedPrimaryTypesState as primaryTypeState[]).map(
          (carouselItem: primaryTypeState) => {
            return {
              id: carouselItem.id,
              name: carouselItem.value,
              blobKey: carouselItem.blobKey || blobUrls[blobIdx++],
            };
          }
        );
        if ((primarySourceOptions.length < 4 || primarySourceOptions.length > 15) && bucketDesign === "1DGrid") {
          setShowSubmitLoader(false);
          setOpenGenericModal(true);
          if (primarySourceOptions.length < 4) {
            setPopupMessage(`You need to select a minimum of 4 ${primaryType.toLowerCase()} to proceed`);
          } else {
            setPopupMessage("Limit exceeded — you can select up to 15 categories only");
          }
          setPopupType("Error");
          return;
        }
        const newBucketPayload: any = {
          ...trimmedTextFieldData,
          titleColor: !titleColorToggle? "#000000" : "#ffffff",
          subTitleColor: !subtitleColorToggle? "#000000" : "#ffffff",
          bucketDesign,
          primarySource: primaryType==="Pack Size"? "pieceSize" : primaryType==="Piece Size Description"? "pieceSizeDesc" : primaryType,
          statusEnabled: true,
          primarySourceOptions,
          viewAll,
          sticky,
          minBoxes,
          bucketStaticColor: bucketStaticColor,
        };
        if (bucketDesign === "1DGrid") {
          newBucketPayload.allSvgPath = "";
        }
        if ((backgroundBlobKey || bucketBackgroundBlobkey)) {
          newBucketPayload["backgroundBlobKey"] =
            backgroundBlobKey || bucketBackgroundBlobkey;
        } else{
          newBucketPayload["backgroundColor"] = bucketBackgroundColor;
        }

        if (view === "create")
          newAllBuckets = [...allBuckets, newBucketPayload];
        else if (view === "edit") {
          const bucketIdx = allBuckets.findIndex(
            (bucket) => bucket.id === bucketTextFieldData.id
          );
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
      } else if (bucketDesign === "Grid") {
        for (
          let primaryIdx = 0;
          primaryIdx < selectedPrimaryTypesState.length;
          primaryIdx++
        ) {
          const primaryTypeOption = selectedPrimaryTypesState[primaryIdx] as primaryTypeState;
          if (primaryTypeOption.inputRef?.files?.[0]) {
            imagesPayload.append("files", primaryTypeOption.inputRef.files[0]);
          }
          const secondaryTypeOptions = primaryTypeOption.secondaryTypeOptions;
          if (secondaryTypeOptions) {
            for (
              let secondaryIdx = 0;
              secondaryIdx < secondaryTypeOptions.length;
              secondaryIdx++
            ) {
              const secondaryTypeOption = secondaryTypeOptions[secondaryIdx];
              if (secondaryTypeOption.inputRef?.files?.[0]) {
                imagesPayload.append(
                  "files",
                  secondaryTypeOption.inputRef.files[0]
                );
              }
            }
          }
        }
        const blobUrls = imagesPayload.has("files")
          ? await uploadImages(imagesPayload)
          : [];
        if (!Array.isArray(blobUrls)) {
          setOpenGenericModal(true);
          setPopupMessage(blobUrls.message);
          setPopupType("Error");
          setShowSubmitLoader(false);
          return;
        }
        let blobIdx = 0;
        const primarySourceOptions = (selectedPrimaryTypesState as primaryTypeState[]).map(
          (gridItem: primaryTypeState) => {
            return {
              id: gridItem.id,
              name: gridItem.value,
              blobKey: gridItem.inputRef?.files?.[0]
                ? blobUrls[blobIdx++]
                : gridItem.blobKey,
              activeStatus: gridItem.activeStatus,
              color: gridItem.color,
              secondarySourceOptions: gridItem.secondaryTypeOptions!.map(
                (gridSecondaryItem: secondaryTypesState) => {
                  return {
                    id: gridSecondaryItem.id,
                    name: gridSecondaryItem.value,
                    blobKey: gridSecondaryItem.inputRef?.files?.[0]
                      ? blobUrls[blobIdx++]
                      : gridSecondaryItem.blobKey,
                  };
                }
              ),
            };
          }
        );
        const newBucketPayload: any = {
          ...trimmedTextFieldData,
          titleColor: !titleColorToggle? "#000000" : "#ffffff",
          subTitleColor: !subtitleColorToggle? "#000000" : "#ffffff",
          bucketDesign,
          primarySource: primaryType==="Pack Size"? "pieceSize" : primaryType==="Piece Size Description"? "pieceSizeDesc" : primaryType,
          secondarySource: secondaryType==="Pack Size"? "pieceSize" :secondaryType==="Piece Size Description"? "pieceSizeDesc": secondaryType,
          statusEnabled: true,
          primarySourceOptions,
          viewAll
        };
        if (view === "create")
          newAllBuckets = [...allBuckets, newBucketPayload];
        else if (view === "edit") {
          const bucketIdx = allBuckets.findIndex(
            (bucket) => bucket.id === bucketTextFieldData.id
          );
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
      }else if(bucketDesign==="Need Based Basket Banner"){
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
          imagesPayload.append("files", bucketBackgroundImage);
        }
        if(bannerIcon && !bannerIconBlobKey){
          imagesPayload.append("files", bannerIcon);
        }
        const blobUrls = imagesPayload.has("files")
          ? await uploadImages(imagesPayload)
          : [];
        if (!Array.isArray(blobUrls)) {
          setOpenGenericModal(true);
          setPopupMessage(blobUrls.message);
          setPopupType("Error");
          setShowSubmitLoader(false);
          return;
        }
        let blobIdx = 0;
        let backgroundBlobKey = "";
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
          backgroundBlobKey = blobUrls[0];
          blobIdx++;
        }
        const bannerIds = (selectedPrimaryTypesState as Banner[]).map((bannerObj: Banner) => {
          return bannerObj.id;
        })
        const newBucketPayload: any = {
          ...trimmedTextFieldData,
          titleColor: !titleColorToggle? "#000000" : "#ffffff",
          subTitleColor: !subtitleColorToggle? "#000000" : "#ffffff",
          bucketDesign,
          bannerIconBlobKey: bannerIconBlobKey || blobUrls[blobIdx],
          bannerId: bannerIds.length>0? bannerIds[0] : "", //for handling previous flow
          bannerIds,
          statusEnabled: true,
          viewAll
        };
        if ((backgroundBlobKey || bucketBackgroundBlobkey)) {
          newBucketPayload["backgroundBlobKey"] =
            backgroundBlobKey || bucketBackgroundBlobkey;
        } else{
          newBucketPayload["backgroundColor"] = bucketBackgroundColor;
        }
        if (view === "create")
          newAllBuckets = [...allBuckets, newBucketPayload];
        else if (view === "edit") {
          const bucketIdx = allBuckets.findIndex(
            (bucket) => bucket.id === bucketTextFieldData.id
          );
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
      }else if(bucketDesign === "basketBannerOneClick"){
        const bannerIds = (selectedPrimaryTypesState as Banner[]).map((bannerObj: Banner) => {
          return bannerObj.id;
        })
        const newBucketPayload: any = {
          ...trimmedTextFieldData,
          titleColor: !titleColorToggle? "#000000" : "#ffffff",
          subTitleColor: !subtitleColorToggle? "#000000" : "#ffffff",
          bucketDesign,
          bannerIds,
          statusEnabled: true,
          viewAll
        };
        if (view === "create")
          newAllBuckets = [...allBuckets, newBucketPayload];
        else if (view === "edit") {
          const bucketIdx = allBuckets.findIndex(
            (bucket) => bucket.id === bucketTextFieldData.id
          );
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
      }else if(bucketDesign==="campaignBanner"){
        
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
          imagesPayload.append("files", bucketBackgroundImage);
        }
        if(bucketGIFImage){
          imagesPayload.append("files", bucketGIFImage);
        }
        if(bannerIcon && !bannerIconBlobKey){
          imagesPayload.append("files", bannerIcon);
        }
        const blobUrls = imagesPayload.has("files")
          ? await uploadImages(imagesPayload)
          : [];
        if (!Array.isArray(blobUrls)) {
          setOpenGenericModal(true);
          setPopupMessage(blobUrls.message);
          setPopupType("Error");
          setShowSubmitLoader(false);
          return;
        }
        let blobIdx = 0;
        let backgroundBlobKey = "";
        let backgroundGIFBlobKey = "";
        if (bucketBackgroundType === "Image" && bucketBackgroundImage) {
          backgroundBlobKey = blobUrls[0];
          blobIdx++;
        }
        if (bucketGIFImage) {
          backgroundGIFBlobKey = blobUrls[blobIdx];
          blobIdx++;
        }
        const bannerIds = (selectedPrimaryTypesState as Banner[]).map((bannerObj: Banner) => {
          return bannerObj.id;
        })
        const newBucketPayload: any = {
          ...trimmedTextFieldData,
          titleColor: !titleColorToggle? "#000000" : "#ffffff",
          subTitleColor: !subtitleColorToggle? "#000000" : "#ffffff",
          bucketDesign,
          bannerIconBlobKey: bannerIconBlobKey || blobUrls[blobIdx],
          bannerId: bannerIds.length>0? bannerIds[0] : "", //for handling previous flow
          bannerIds,
          statusEnabled: true,
          startDate:startDate?.format("YYYY-MM-DD") + " 00:00:00",
          endDate:endDate?.format("YYYY-MM-DD") + " 23:59:59"
        };
        // console.log("newBucketPayload",newBucketPayload)
        
        if ((backgroundBlobKey || bucketBackgroundBlobkey)) {
          newBucketPayload["backgroundBlobKey"] =
            backgroundBlobKey || bucketBackgroundBlobkey;
        } else{
          newBucketPayload["backgroundColor"] = bucketBackgroundColor;
        }
        
        if(backgroundGIFBlobKey || bucketBackgroundGIF){
          newBucketPayload["backgroundGIFBlobKey"] = backgroundGIFBlobKey || bucketBackgroundGIF;
        }
        if (view === "create")
          newAllBuckets = [...allBuckets, newBucketPayload];
        else if (view === "edit") {
          const bucketIdx = allBuckets.findIndex(
            (bucket) => bucket.id === bucketTextFieldData.id
          );
          newAllBuckets[bucketIdx] = newBucketPayload;
        }
      }
      bucketConfiguration[0].value = newAllBuckets;
      const finalMetaDataPayload: metaDataBatchPayload = { features: [] };
      let bucketPayload = {
        domainName: "clientconfig",
        domainType: "bucket_configuration",
        domainValues: bucketConfiguration ,
        lob: getLob()
      };
      finalMetaDataPayload.features.push(bucketPayload);
      if(blockSelectionState.isChanged && blockSelectionState.blockConfigEnabled && blockSelectionState.selectedBlock.id){
        const blockPayload = getBlockMetaData(savedRole?.id,trimmedTextFieldData.id,blockSelectionState.selectedBlock,clientConfigRef.current);
        if(blockPayload){
          finalMetaDataPayload.features.push(blockPayload);
        }
        const wholeSellerLayoutConfig = getClientConfigDomainType(clientConfigRef.current,"wholesaler_app_layout_configuration");
        if(wholeSellerLayoutConfig && wholeSellerConfig){
            const role = "retailer";
            const configName = `${role}_app_layout_configuration`;
            const roleAppLayoutConfig = getClientConfigDomainType(clientConfigRef.current,configName);
            const updatedRoleLayoutConfig = getUpdatedRoleAppLayoutConfig(roleAppLayoutConfig,blockSelectionState.selectedBlock,trimmedTextFieldData.id);
            const wholeSellerConfigData = await getWholeSellerConfiguration(clientConfigRef.current,updatedRoleLayoutConfig);
            if(wholeSellerConfigData && wholeSellerConfig){
              finalMetaDataPayload.features.push(wholeSellerConfigData);
            }
        }
      }
      validateWithOtp((verifiedOTPUser?: manageUpdateAccessObj,verifyResponse?: any)=>{
        doFinalSubmit(verifiedOTPUser,verifyResponse);
      },undefined,"all",META_DATA_BATCH_API,finalMetaDataPayload,"PUT")
      setShowSubmitLoader(false);
      
    } catch (err) {
      setShowSubmitLoader(false);
      setPopupMessage(`Something went wrong while creating bucket, Please try again`);
      setPopupType("Error");
      setOpenGenericModal(true);
    }
  }

  const doFinalSubmit=async (verifiedUser?: manageUpdateAccessObj,verifyResponse?: any)=>{
    if (verifyResponse.status === 200 || verifyResponse.status === 201) {
      const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
      if(validationObj.success){
        setPopupMessage(
          `Bucket with ID: ${bucketTextFieldData.id} ${view==="create"?"created": "updated"} successfully`
        );
        setShowSubmitLoader(false);
        setPopupType("Success");
        setOpenGenericModal(true);
      }else{
        setPopupMessage(
          validationObj.message
        );
        setShowSubmitLoader(false);
        setPopupType("Error");
        
      }
      setOpenGenericModal(true);
    } else {
      throw new Error();
    }
  }
  function renderHeaderName(){
    if(view==="create"){
      return  translate(TranslationEnum.manage_bucket,"Create Bucket");
    }else if(view==="edit"){
      const bucketDesignLabel = bucketDesigns.find((option) => option.id === currentBucketLocationData.bucketDesign)?.label;
      if(hideAllInputs){
        return primaryType? translate(TranslationEnum.manage_bucket,"Manage {primaryType} {bucketDesignLabel}",{"primaryType":primaryType,"bucketDesignLabel":bucketDesignLabel ?? ""}): translate(TranslationEnum.manage_bucket,"Manage {bucketDesignLabel}",{"bucketDesignLabel":bucketDesignLabel?? ""});
      }else{
        return translate(TranslationEnum.manage_bucket,"Edit {primarySource} {bucketDesignLabel}",{"primarySource":currentBucketLocationData.primarySource? currentBucketLocationData.primarySource: "Bucket","bucketDesignLabel":bucketDesignLabel ?? ""});
      }
    }
    return "";
  }
  return (
    <div className="create-bucket-parent">
      {!showLoader?<>
        <div className="create-bucket-label">
          <span>{renderHeaderName()}</span>
          <div className='edit-bucket-header-buttons-container'>
              {hideAllInputs && <button
                  className="create-bucket-label-back-button create-bucket-secondary-color"
                  onClick={() => {
                    setHideAllInputs(false);
                  }}
              >
                 {translate(TranslationEnum.common_portal,"EDIT")}
              </button>}
              <BackButton/>
            </div>
        </div>
        <div className="create-basket-input-fields">
          
          {!hideAllInputs && <>
            {view === "edit" && <>
            <label className="create-basket-input-labels">{translate(TranslationEnum.manage_bucket,"ENTER ID")}</label>
            <TextField
              id="outlined-start-adornment"
              size="small"
              value={bucketTextFieldData.id}
              disabled={view==="edit"}
              placeholder={translate(TranslationEnum.manage_bucket,"Enter Id")}
              onChange={(event) => {
                const value = event.target.value;
                if(!bucketTextFieldFlag.id) setBucketTextFieldFlag({...bucketTextFieldFlag, id: true});
                setBucketTextFieldData({ ...bucketTextFieldData, id: value });
              }}
              error = {bucketTextFieldFlag.id && Boolean(idHelperText)}
              helperText = {bucketTextFieldFlag.id && idHelperText}
          /></>}
          <label className="create-basket-input-labels">{translate(TranslationEnum.manage_bucket,"BUCKET DESIGN")}</label>
            <Autocomplete
            disableClearable
            sx={{ width: "100%" }}
            disabled={view==="edit" || locationState?.blockData}
            onChange={(event, value: { id: string, label: string }) => {
              setBucketDesignOption(value);
              setBucketDesign(value.id);
              setSelectedPrimaryTypesState([]);
              setPrimaryType("");
              setPrimaryTypeOptions([]);
              setSecondaryType("");
              if(blockSelectionState.blockConfigEnabled){
                const availableBlockOptions = getAvailableBlockOptionsOfType("Bucket",allBlocksRef.current,value.id)
                if(blockSelectionState.blockConfigEnabled && blockSelectionState.selectedBlock && view==="create") setBlockSelectionState((prevState) => {
                  return { ...prevState, selectedBlock: defaultBlockObj}
                })
                setBlockSelectionState({
                  ...blockSelectionState,
                  blockOptions: availableBlockOptions
                })
              }
              if(selectedPrimaryTypes.length) setSelectedPrimaryTypes([]);
              if(secondaryBucketTypes.length>0) setSecondaryBucketTypes([]);
              if(gridDataMapping.length>0) setGridDataMapping([]);
              if(value.id==="Grid" || value.id ==="Carousel" || value.id ==="1DGrid"){
                  if(bucketBackgroundImage) setBucketBackgroundImage(null);
                  if(bucketBackgroundColor) setBucketBackgroundColor("#ffffff");
                  // if(bucketStaticColor) setBucketStaticColor("#ffffff");
                  if(bucketBackgroundBlobkey) setBucketBackgroundBlobkey("")
                  if(bucketBackgroundType==="Image") setBucketBackgroundType("Color");
              }
              if (value.id === "1DGrid" && !allowed1DGrid) {
                openPopup("Error", "You can create only one carousel");
                setBucketDesign("");
                setBucketDesignOption({
                  label: "",
                  id: ""
                });
                return;
              }
            }}
            value={bucketDesignOption}
            options={bucketDesigns}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={translate(TranslationEnum.manage_bucket,"Select Bucket Design")}
              />
            )}
          />
          {(bucketDesign && bucketDesign!=="1DGrid" )&& <>
          <label className="create-basket-input-labels">{translate(TranslationEnum.manage_bucket,"BUCKET TITLE")}</label>
          <TextField
            id="outlined-start-adornment"
            size="small"
            value={bucketTextFieldData.title}
            placeholder={translate(TranslationEnum.manage_bucket,"Enter Bucket Title")}
            onChange={(event) => {
              const value = event.target.value;
              if(!bucketTextFieldFlag.title) setBucketTextFieldFlag({...bucketTextFieldFlag, title: true});
              setBucketTextFieldData({ ...bucketTextFieldData, title: value });
            }}
            error = { bucketTextFieldFlag.title && Boolean(titleHelperText) }
            helperText = { bucketTextFieldFlag.title && titleHelperText }
          />
          <div className="create-basket-input-labels">
              <span>{translate(TranslationEnum.manage_bucket,"TITLE COLOR")}</span>
              <Switch
                onChange={() => {
                  // setTitleColor(!titleColor);
                  setTitleColorToggle(!titleColorToggle);
                }}
                checked={titleColorToggle}
                offColor="#000000"
                onColor="#ffffff"
                onHandleColor="#000000"
                offHandleColor="#ffffff"
                size={22}
                handleDiameter={19}
                uncheckedIcon={
                  <>
                    <div className="create-checked-color-status">{translate(TranslationEnum.manage_bucket,"BLACK")}</div>
                  </>
                }
                checkedIcon={
                  <>
                    <div className="create-unchecked-color-status">{translate(TranslationEnum.manage_bucket,"WHITE")}</div>
                  </>
                }
                height={23}
                width={65}
                className="create-basket-color-switch"
              />
            </div>
          <label className="create-basket-input-labels">{translate(TranslationEnum.manage_bucket,"BUCKET SUBTITLE")}</label>
          <TextField
            id="outlined-start-adornment"
            size="small"
            value={bucketTextFieldData.subtitle}
            placeholder={translate(TranslationEnum.manage_bucket,"Enter Bucket Subtitle")}
            onChange={(event) => {
              const value = event.target.value;
              if(!bucketTextFieldFlag.subtitle) setBucketTextFieldFlag({...bucketTextFieldFlag, subtitle: true});
              setBucketTextFieldData({ ...bucketTextFieldData, subtitle: value });
            }}
            error = { bucketTextFieldFlag.subtitle && Boolean(subtitleHelperText) }
            helperText = { bucketTextFieldFlag.subtitle && subtitleHelperText }
          />
          <div className="create-basket-input-labels">
              <span>{translate(TranslationEnum.manage_bucket,"SUBTITLE COLOR")}</span>
              <Switch
                onChange={() => {
                  setSubtitleColorToggle(!subtitleColorToggle);
                }}
                checked={subtitleColorToggle}
                offColor="#000000"
                onColor="#ffffff"
                onHandleColor="#000000"
                offHandleColor="#ffffff"
                size={22}
                handleDiameter={19}
                uncheckedIcon={
                  <>
                    <div className="create-checked-color-status">{translate(TranslationEnum.manage_bucket,"BLACK")}</div>
                  </>
                }
                checkedIcon={
                  <>
                    <div className="create-unchecked-color-status">{translate(TranslationEnum.manage_bucket,"WHITE")}</div>
                  </>
                }
                height={23}
                width={65}
                className="create-basket-color-switch"
              />
            </div>
          </>}
          {blockSelectionState.blockConfigEnabled &&
           <>
            <label className="create-basket-input-labels">BLOCK</label>
            <Autocomplete
                  disablePortal
                  // disabled={isEdit}
                  disabled={locationState?.blockData}
                  size="small"
                  id="bannerTemplateTypes"
                  options={blockSelectionState.blockOptions}
                  getOptionLabel={(option) => {
                      return option.id?  (option.id + " - " + option.name) : "" ;
                  }}
                  value={blockSelectionState.selectedBlock}
                  onChange={(e,value) => {
                    if(value)
                      setBlockSelectionState({
                        ...blockSelectionState,
                        selectedBlock: value,
                        isChanged: true
                      })
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Select Block to link" />}
              />
          </>
          }
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
             {bucketDesign && bucketDesign !== "1DGrid" &&
           <FormControlLabel
              sx={{ mt: 1.5 }}
              control={
                <MUISwitch
                  checked={viewAll === true}
                  onChange={handleToggle}
                />
              }
              label={translate(TranslationEnum.manage_bucket, "View All")}
            />
}
            {bucketDesign === "1DGrid" && <FormControlLabel
              sx={{ mt: 1.5 }}
              control={
                <MUISwitch
                  checked={sticky === true}
                  onChange={handleStickyToggle}
                />
              }
              label={translate(TranslationEnum.manage_bucket, "Sticky")}
            />}
            </div>
          {bucketDesign==="Carousel" || bucketDesign==="1DGrid" || bucketDesign==="Need Based Basket Banner"?<div className="create-basket-input-labels" style={{display:"flex",gap:"10px"}}>
            BACKGROUND TYPE{" "}
            <Switch
              onChange={(checked) => {
                setBucketBackgroundImage(null);
                setBucketBackgroundColor("#ffffff");
                if(!checked) setBucketBackgroundBlobkey("")
                setBucketBackgroundType(checked ? "Image" : "Color");
              }}
              checked={bucketBackgroundType === "Image"}
              offColor="#237c9d"
              onColor="#24c6b1"
              disabled={bucketDesign==="Carousel"}
              size={22}
              handleDiameter={19}
              uncheckedIcon={
                <>
                  <div className="toggle-unchecked-icon-status">COLOR</div>
                </>
              }
              checkedIcon={
                <>
                  <div className="toggle-checked-icon-status">IMAGE</div>
                </>
              }
              height={23}
              width={65}
            />
             {bucketDesign === "1DGrid" && (
                <Tooltip
                  title="Changes apply to both app header and row, overriding any previous header style."
                  placement="right"
                  arrow
                  // componentsProps={{
                  //   tooltip: { sx: { bgcolor: 'red !important', color: '#fff !important' } },
                  //   arrow: { sx: { color: 'red !important' } },
                  // }}
                >
                  <InfoOutlinedIcon fontSize="small" style={{ cursor: "pointer", color: "#888" }} />
                </Tooltip>
    )}
          </div>:<></>}
          {renderBackgroundInput()}
          {bucketDesign==="campaignBanner"?<div style={{marginTop:"15px"}}>
          GIF{" "}
          <UploadImageButton
          maxGifSize={maxGifSize}
          allowedType="both"
                    label={"GIF"}
                    setImage={setBucketGIFImage}
                    image = {bucketGIFImage}
                    defaultImage={bucketBackgroundGIF}
                    setDefaultImage={setBucketBackgroundGIF}
                    resolution={{
                      width: 1024,
                      height: 600
                    }}
                  />
                  <div style={{marginTop:"25px"}}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack direction="row" spacing={3}>
                  <DesktopDatePicker
                    label={translate(TranslationEnum.common_portal, "Start Date")}
                    inputFormat="DD/MM/YYYY"
                    value={startDate}
                    onChange={handleStartDate}
                    renderInput={(params) => <TextField {...params} error={Boolean(dateValidation.startDate)} helperText={dateValidation.startDate} />}
                  />
                  <DesktopDatePicker
                    label={translate(TranslationEnum.common_portal, "End Date")}
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    onChange={handleEndDate}
                    renderInput={(params) => <TextField {...params} error={Boolean(dateValidation.endDate)} helperText={dateValidation.endDate} />}
                  />
                </Stack>
              </LocalizationProvider>
                  </div>
         
          </div>:<></>}
                      {bucketDesign === "1DGrid" && <>
              {<><label className="create-basket-input-labels" style={{display:"flex",gap:"10px"}}>{translate(TranslationEnum.manage_bucket,"OVERLAY COLOR")}
                 <div style={{ fontSize: "12px", color: "#1C7EA0",marginLeft:"0px",backgroundColor: "#d6e4ec",padding:"3px",borderRadius:"2px" }}>
                 (Enabled only when layout is Sticky with an Image background)
                </div>
                <Tooltip title="If left empty, the image stays while scrolling. If set, this color replaces the image." placement="right"
                  arrow
                  // componentsProps={{
                  //   tooltip: { sx: { bgcolor: 'red !important', color: '#fff !important' } },
                  //   arrow: { sx: { color: 'red !important' } },
                  // }}
                  >
                  <InfoOutlinedIcon fontSize="small" style={{ cursor: "pointer", color: "#888" }} />
                </Tooltip>
                </label> 
              <TextField
                id="outlined-start-adornment"
                size="small"
                value={bucketStaticColor}
                placeholder={"Select Overlay Color"}
                onChange={handleStaticColorChange}
                InputProps={{
                  endAdornment: (
                    <input
                      style={{padding: "0",width:"60px"}}
                      type="color"
                      id="color-picker"
                      value={bucketStaticColor}
                      onChange={handleStaticColorChange}
                      disabled={(bucketBackgroundType !== "Image" || !sticky)}
                    />
                  ),
                }}
                disabled={(bucketBackgroundType !== "Image" || !sticky)}
                error={!isValidColor}
                helperText={!isValidColor && "Please select a valid hex code"}
                  sx={{
                    "& .MuiOutlinedInput-root.Mui-disabled": {
                      backgroundColor: "#F8F8F8",
                    },

                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-input::placeholder": {
                      color: "#A2A2A2",
                      opacity: 1,
                    },

                    "& .MuiOutlinedInput-input.Mui-disabled": {
                      color: "#A2A2A2",
                      WebkitTextFillColor: "#A2A2A2",
                    },

                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "transparent",
                    },
                  }}
              /></>}
              {/* <label className="create-basket-input-labels">{translate(TranslationEnum.manage_bucket,"MIN BOXES")}</label> 
              <TextField
                type="number"
                size="small"
                value={minBoxes}
                onChange={(e) => setMinBoxes(e.target.value)}
                placeholder="Enter number"
                inputProps={{ min: 0 }}
              /> */}
            </>
            }
          {bucketDesign==="Carousel" || bucketDesign === "Grid" || bucketDesign === "1DGrid" ?<><label className="create-basket-input-labels">BUCKET TYPE</label>
          <Autocomplete
            disableClearable
            sx={{ width: "100%" }}
            value={primaryType}
            onChange={async (event, value: string) => {
              setPrimaryType(value);
              if (value === "Pack Size") {
                setPrimaryTypeOptions(packSizes);
              } else if (value === "Category") {
                setPrimaryTypeOptions(categories);
              } else if(value === "Brand") {
                setPrimaryTypeOptions(brands);
              }else if(value === "Sub Category") {
                setPrimaryTypeOptions(subCategory);
              }else if(value === "Sub Brand") {
                setPrimaryTypeOptions(subBrand);
              } else if(value === "Piece Size Description") {
                setPrimaryTypeOptions(pieceSizeDesc);
              }else if(value === "Brand Code") {
                setPrimaryTypeOptions(brandCode);
              }else{
                setPrimaryTypeOptions(smartBuys);
              }
              if(selectedPrimaryTypesState.length>0) setSelectedPrimaryTypesState([]);
              if(selectedPrimaryTypes.length) setSelectedPrimaryTypes([]);
              if(secondaryType) setSecondaryType("");
              setSecondaryBucketTypes(
                bucketTypes.filter((option: string) => option !== value)
              );
            }}
            options={bucketTypes.filter((option: string) => option !== secondaryType)}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={translate(TranslationEnum.manage_bucket,"Select Bucket Type")}
              />
            )}
          /></>:<></>}</>}
          {renderBucketTypeInputs()}
          <div className="create-bucket-submit-button-container">
            <button
              onClick={() => handleBucketSubmit()}
              className="create-bucket-submit-button"
              disabled={showSubmitLoader}
            >
              {showSubmitLoader? (
                <div>
                  <CircularProgress size={15} color="inherit" />
                  <span className="circular-progress-container ">{translate(TranslationEnum.common_portal,"SUBMIT")}</span>
                </div>
              ) : (
                <>{translate(TranslationEnum.common_portal,"SUBMIT")}</>
              )}
            </button>
          </div>
        </div>
      </>: <Loader />}
      <GenericPopUp
        type={popupType}
        message={popupMessage}
        setOpenGenericModal={popupType==="Success"?() => {
            setOpenGenericModal(false);
            window.history.back();
          }: setOpenGenericModal}
        openGenericModal={openGenericModal}
      />
    </div>
  )
}

export default CreateBucket;


